export default "__VITE_ASSET__BUsbShpu__"